import { getItemList } from "./getItemList";
import { shopItemDelete, okposItemDelete } from "../lib/ec2-api-lib";
import { sortObjArray2 } from "../lib/utils";
import { debug } from "../settings";


// /** @make_itemList_unique delete duplicate items */
// export async function makeItemListUnique({ shopInfo, setComment }) {
//   try {

//     let res = {}
//     res = await getItemList({ shopInfo });
//     if (res.err) throw new Error(res.err.message);

//     const serverItems = res.result.Items

//     const itemListUnique = getUniqueItemList(serverItems)
//     const itemListToDel = getItemListToDel(serverItems, itemListUnique)

//     // console.log("=".repeat(20), 'make unique itemList', serverItems.length);
//     // const itemListToDel2 = getShortArray(itemListToDel, [
//     //   "id",
//     //   "groupCode",
//     //   "itemCode",
//     //   "itemName",
//     //   "price",
//     // ])
//     // console.log("-".repeat(20), 'items to delete');
//     // console.table(itemListToDel2)


//     if (itemListToDel.length > 0) setComment("중복 아이템 삭제 중")

//     let errMsg = ""
//     for (let i = 0; i < itemListToDel.length; i++) {
//       const delItem = itemListToDel[i]
//       let res = await shopItemDelete({ shopId: shopInfo.shopId, id: delItem.id })
//       if (res.err) {
//         errMsg = "메뉴아이템 삭제 중 에러가 발생했습니다. 한번 더 수행해 주세요! " + res.err.message
//         break;
//       }
//     }
//     if (errMsg !== "") throw new Error(errMsg);

//     return { itemListUnique }
//   } catch (e) {
//     return { err: { message: e.message } }
//   }
// }

// function getUniqueItemList(itemList) {
//   const newList = []
//   const itemList2 = sortObjArray2({ arr: itemList, key: "image", type: 'down' })
//   const itemList3 = sortObjArray2({ arr: itemList2, key: "itemCode" })
//   itemList3.map(item => {
//     const items = newList.filter(o => o.itemCode === item.itemCode)
//     if (items.length === 0) newList.push(item)
//     return null
//   })
//   return newList
// }

// function getItemListToDel(itemList, itemListUnique) {
//   const itemListToDel = []
//   itemList.map(item => {
//     const items = itemListUnique.filter(o => o.id === item.id)
//     if (items.length === 0) itemListToDel.push(item)
//     return null
//   })
//   return itemListToDel
// }

/** @make_itemList_unique delete duplicate items */
export async function makeItemListUnique({ shopInfo, setComment }) {
  try {

    // console.log('posName', shopInfo.posName)
    setComment('Make ItemList Unique')

    let res = {}
    res = await getItemList({ shopInfo });
    if (res.err) throw new Error(res.err.message);

    const itemList = res.result.Items

    const itemList2 = sortObjArray2({ arr: itemList, key: "image", type: 'down' })
    const itemList3 = sortObjArray2({ arr: itemList2, key: "itemCode" })
    const newList = []

    let errMsg = ""
    for (let i = 0; i < itemList3.length; i++) {
      const item = itemList3[i]
      const items = newList.filter(o => o.itemCode === item.itemCode)

      if (items.length === 0) {
        newList.push(item)
      }
      else {
        if (debug) console.log('deleting', item.itemCode, item.itemName)

        let res = {}
        const params = { shopId: shopInfo.shopId, id: item.id }

        if (shopInfo.posName === "OKPOS") {
          res = await okposItemDelete(params)
        } else {
          res = await shopItemDelete(params)
        }

        if (res.err) {
          errMsg = "메뉴아이템 삭제 중 에러가 발생했습니다. 한번 더 수행해 주세요! " + res.err.message
          break;
        }
      }
    }
    if (errMsg !== "") throw new Error(errMsg);

    if (debug) console.log('newList len', newList.length)

    return {}
  } catch (e) {
    return { err: { message: e.message } }
  }
}